import fileName from '@/utils/formatting/file-name';
import axios from 'axios';
import request from '@/utils/api/request';
import parseError from '@/utils/formatting/parse-error';

const uploadFiles = {
  props: {
    fileLinks: {
      type: Array,
      default: () => [],
    },
    addApiEndpoint: {
      type: String,
      default: '/tenders/files/',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fileIdx: 1,
      uploadedFiles: [],
    };
  },
  methods: {
    uploadFiles(files) {
      this.$emit('loading-started');
      files.forEach((file) => this.createFile(file));
    },
    async createFile(file) {
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();

      let fd = new FormData();
      fd.set('file', file);

      let newFile = {
        file,
        source,
        uploading: true,
        percent: 0,
        fileIdx: this.fileIdx++,
        id: 0,
        formatError: false,
        errorText: null,
      };

      const config = {
        onUploadProgress: (event) => {
          newFile.percent = Math.round((event.loaded * 100) / event.total);
        },
        cancelToken: source.token,
      };

      this.uploadedFiles.push(newFile);

      try {
        let { data } = await request.post(this.addApiEndpoint, fd, config);
        this.uploadedFiles[this.uploadedFiles.length - 1] = {
          ...this.uploadedFiles[this.uploadedFiles.length - 1],
          ...data,
        };
        newFile.id = data.id;
        this.$emit(
          'change-files-id',
          this.uploadedFiles.map((file) => file.id)
        );

        this.emitFilesChanging();
      } catch (e) {
        newFile.formatError = true;
        newFile.errorText = parseError(e);
      }

      newFile.uploading = false;
    },
    handleDeletion(file) {
      if (file.uploading) {
        file.source.cancel();
      }
      this.removeFile(file.id);
      this.$emit('delete-file', file.id);
    },
    removeFile(id) {
      this.uploadedFiles = this.uploadedFiles.filter((uploadedFile) => uploadedFile.id !== id);
      this.emitFilesChanging();
    },
    emitFilesChanging() {
      this.$emit(
        'change-files',
        this.uploadedFiles.filter((file) => !file.formatError)
      );
    },
  },
  created() {
    this.uploadedFiles = this.fileLinks.map((file) => {
      return {
        ...file,
        file: {
          name: fileName(file.file),
        },
      };
    });
  },
};

export default uploadFiles;
